import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";
import Submenu from "./Submenu";

export default class Button extends BaseComponent {
    /**
     * Button component
     * @module Button
     * @param {Object} props React props
     */
    constructor(props) {
        super(props);
        this.state = {
            class: this.props.type ? this.props.type : "normal",
            asLink: this.props.asLink ? ' asLink ': '',
            wide: this.props.wide ? " wide" : "",
            desc: this.props.desc ? this.props.desc : "",
            submenu: this.props.submenu,
            context: this.props.context ? this.props.context : this,
            showJsx: false,
            icon: this.props.icon ? "fe " + this.props.icon : "",
            tint: this.props.tint ? " " + this.props.tint : ""
        };
    }

    getLabel(){
        return this.props.label ? this.props.label : this.getPropLabel("untitled");
    }

    /**
     * Get reference to button itself
     * @returns {jQuery}
     */
    getDomSelf(){
        return $(ReactDOM.findDOMNode(this)).children(".form-button");
    }

    /**
     * Hide the attached submenu
     */
    removeSubmenu(){
        this.setState({ showJsx: false });
    }

    /**
     * React render
     * @returns {XML}
     */
    render(){
        const { callback } = this.props;
        return (
            <div className={"form-component-container"} style={{display: "flex", alignItems: "center"}}>
                <button
                    className={"form-button " + this.state.class + this.state.asLink + this.state.wide + this.state.tint + (this.props.disabled ? ' disabled': ' ')}
                    style={this.props.style}
                    onClick={event => {
                        if(this.props.disabled){
                            return false;
                        }
                        if (callback === "__submenu"){
                            // Show submenu if the button is a submenu type
                            this.setState({ showJsx: true });
                        } else {
                            // Do callback for every other types
                            callback(event, this.getDomSelf(), this.state.context);
                        }
                        event.preventDefault();
                        event.stopPropagation();
                    }}
                >
                {this.props.isLoading &&
                    <span
                        style={{ padding: "0px 6px", display: "inline-block" }}
                        className="glyphicon glyphicon-refresh glyphicon-refresh-animate"
                    ></span>
                }
                {(() => {
                    if (this.state.icon){
                        return <i className={this.state.icon}/>;
                    }
                    else if(this.props.labelIcon){
                        return (<span><i className={`fe icon-${this.props.labelIcon}`} style={{paddingRight: '.5em'}}/>{this.getLabel()}</span>)
                    }
                    else{
                        return this.getLabel();
                    }
                    
                })()}</button>{(() => {
                if (this.state.desc !== '') {
                  return (
                    <label style={{ marginLeft: '10px', marginBottom: 0, position: 'inherit' }}>
                      {this.state.desc}
                      {!this.props.tooltip ? null : (
                        <span data-tip={this.props.tooltip}>
                          <i className="fe icon-info" />
                        </span>
                      )}
                    </label>
                  );
                }
            })()}
                {(() => {
                    if (this.state.showJsx){
                        // Attach a submenu with a pre-defined submenu view
                        return <Submenu content={this.state.submenu} context={this.state.context} domContext={this}
                                        params={this.props.menuParams}/>;
                    }
                })()}
            </div>
        );
    }
}
